import React, { Component } from "react";
import myImage from "../images/Robert_350x350.png";
import patreon from "../images/patreon.png";
import kofi from "../images/kofi.png";

export default class UserInfo extends Component {
  render() {
    return (
      <aside className="note">
        <div className="container note-container">
          <div className="flex-author">
            <div className="flex-avatar">
              <img className="avatar" src={myImage} alt="Robert Livingston" />
            </div>
            <div>
              <p>
                I'm Robert Livingston. I try to create things that are fun to look at or listen to. I also like to talk about technology.{" "}
                <strong>
                  I'll never use advertisements or sponsors. If you like what you see, please consider supporting what I do.
                </strong>
              </p>

              <div className="flex">
                <a
                  href="https://ko-fi.com/mindshaver"
                  className="donate-button"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={kofi} className="coffee-icon" alt="Coffee icon" />
                  Buy me a coffee
                </a>
                <a
                  className="patreon-button"
                  href="https://www.patreon.com/rllivingston"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={patreon} height="50" width="50" alt="Patreon" />{" "}
                  Become a Patron
                </a>
              </div>
            </div>
          </div>
        </div>
      </aside>
    );
  }
}
